// extracted by mini-css-extract-plugin
module.exports = {"testimoniesCard":"testimoniesCard-module--testimoniesCard--220BM","testimoniesCard_heading":"testimoniesCard-module--testimoniesCard_heading--1GS54"};